import { t } from '@moovly/i18n';
import { IconDelete, Select } from '@moovly/ui';

import * as React from 'react';
import { TableAction } from '../../../../components/Table';
import { Member } from '../../../../types/member';
import UserRoleSelectContainer from '../../containers/UserRoleSelectContainer';

import './OrganizationUserInfo.scss';

interface OrganizationUserInfoProps {
  memberships: Member[];
  addToGroupOptions: { value: string; label: string }[];
  onAddToGroup: (groupId: string) => void;
  onRemoveMemberFromGroup: (memberId: string, groupId: string) => void;
}

const OrganizationUserInfo: React.FC<OrganizationUserInfoProps> = ({
  memberships,
  addToGroupOptions,
  onAddToGroup,
  onRemoveMemberFromGroup,
}) => {
  const [addToGroup, setAddToGroup] = React.useState<string>();

  const handleAddToGroupChange = React.useCallback(({ value }: { value: string }) => {
    setAddToGroup(value);
  }, []);
  const handleAddToGroup = React.useCallback(() => {
    onAddToGroup(addToGroup!);
    setAddToGroup(undefined);
  }, [onAddToGroup, addToGroup]);
  const handleRemove = React.useCallback(
    (memberId: string, groupId: string) => () => {
      onRemoveMemberFromGroup(memberId, groupId);
    },
    [onRemoveMemberFromGroup]
  );
  return (
    <div className="OrganizationUserInfo">
      <h4 className="mb-4 text-uppercase">{t('user.organizations.hasAccessTo')}</h4>

      <ul className="Memberships">
        {memberships.map((member) => (
          <li className="Membership">
            <h6 className="Name">{member.group?.name}</h6>
            <div className="RoleSelect">
              <UserRoleSelectContainer membership={member} />
            </div>
            <TableAction icon={IconDelete} onClick={handleRemove(member.id, member.group_id)} />
          </li>
        ))}
        <li>
          <div>
            <h5>{t('user.organizations.addUser.title')}</h5>
            <div className="Create-Container">
              <div className="Select">
                <Select
                  placeholder={t('user.organizations.addUser.placeholder')}
                  onChange={handleAddToGroupChange}
                  options={addToGroupOptions}
                  value={addToGroupOptions.find((o) => o.value === addToGroup)}
                />
              </div>
              <button onClick={handleAddToGroup} disabled={!addToGroup} className="btn btn-secondary">
                {t('user.organizations.addUser.submit')}
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default OrganizationUserInfo;
